exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".body_info {\n  padding: 20px; }\n", ""]);

// exports
